import PropTypes from "prop-types"
import React from "react"
import { Link, useStaticQuery } from "gatsby"

import "../css/hr-info.css"

import shield from "../images/hourglass.webm"
import { HandleImages } from "./functions"
import Img from "gatsby-image"
import bike from "../images/bike.webm"
import door from "../images/door.webm"
import OnVisible from "react-on-visible"

import pAIcon from "../images/project-ares-logo.svg"
import arrow from "../images/arrow.webm"
import student from "../images/student.webm"

import map from "../images/map.webm"
const style = {}
var height
var position
 

class GovInfo extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: true,
      active: true,
      
    }
  }

  componentDidMount() {
  this.setState({
      safari:!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)
  })
   
    var current = this
    console.log("mount", this.state.active)

 
  }

  render() {
    return (
      <div className="hr-info-wrapper">
       
 <div className='top'>
            
 <div className='left'>
 <OnVisible className="messages">
  <div className='message'>
       <div><span>Gosh, finding top cyber talent is hard!</span></div><div className="icon"><svg version="1.1"   x="0px" y="0px"  viewBox="0 0 51.6 51.6" >
 
<path class="st0" d="M25.8,0C11.6,0,0,11.6,0,25.8c0,8.3,3.9,15.7,10.1,20.5c4.4,3.4,9.8,5.3,15.7,5.3c5.9,0,11.4-2,15.7-5.3
    c6.1-4.7,10.1-12.1,10.1-20.5C51.6,11.6,40.1,0,25.8,0z M25.8,9.1c4.3,0,7.9,3.5,7.9,7.9c0,4.3-3.5,7.9-7.9,7.9s-7.9-3.5-7.9-7.9
    C17.9,12.6,21.5,9.1,25.8,9.1z M41.5,38.6c0,0.8-0.7,1.5-1.5,1.5c-8.5,0.5-20.3,0.4-28.4-0.1c-0.8-0.1-1.5-0.7-1.5-1.6
    c0-5.1,1.8-9.7,4.6-13c0.7-0.8,1.4-1.5,2.2-2.2c0.4-0.3,1-0.3,1.4,0.1c1.1,1.3,2.6,2.3,4.4,3c1,0.4,2,0.5,3.1,0.5
    c2.7,0,5.6-1.3,7.6-3.5c0.3-0.4,1-0.5,1.4-0.1C38.8,26.6,41.5,32.2,41.5,38.6L41.5,38.6z"/>
<path class="st1" d="M25.8,9c-4.4,0-8,3.6-8,8c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8C33.8,12.6,30.2,9,25.8,9z M25.8,24.9
    c-4.3,0-7.9-3.5-7.9-7.9c0-4.3,3.5-7.9,7.9-7.9s7.9,3.5,7.9,7.9C33.7,21.3,30.2,24.9,25.8,24.9z"/>
</svg></div>
   </div>
   <div className='message'>
       <div><span>I need to ensure that applicants have critical cyber skills our hiring managers are looking for</span></div><div className="icon"><svg version="1.1"   x="0px" y="0px"  viewBox="0 0 51.6 51.6" >
 
 <path class="st0" d="M25.8,0C11.6,0,0,11.6,0,25.8c0,8.3,3.9,15.7,10.1,20.5c4.4,3.4,9.8,5.3,15.7,5.3c5.9,0,11.4-2,15.7-5.3
     c6.1-4.7,10.1-12.1,10.1-20.5C51.6,11.6,40.1,0,25.8,0z M25.8,9.1c4.3,0,7.9,3.5,7.9,7.9c0,4.3-3.5,7.9-7.9,7.9s-7.9-3.5-7.9-7.9
     C17.9,12.6,21.5,9.1,25.8,9.1z M41.5,38.6c0,0.8-0.7,1.5-1.5,1.5c-8.5,0.5-20.3,0.4-28.4-0.1c-0.8-0.1-1.5-0.7-1.5-1.6
     c0-5.1,1.8-9.7,4.6-13c0.7-0.8,1.4-1.5,2.2-2.2c0.4-0.3,1-0.3,1.4,0.1c1.1,1.3,2.6,2.3,4.4,3c1,0.4,2,0.5,3.1,0.5
     c2.7,0,5.6-1.3,7.6-3.5c0.3-0.4,1-0.5,1.4-0.1C38.8,26.6,41.5,32.2,41.5,38.6L41.5,38.6z"/>
 <path class="st1" d="M25.8,9c-4.4,0-8,3.6-8,8c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8C33.8,12.6,30.2,9,25.8,9z M25.8,24.9
     c-4.3,0-7.9-3.5-7.9-7.9c0-4.3,3.5-7.9,7.9-7.9s7.9,3.5,7.9,7.9C33.7,21.3,30.2,24.9,25.8,24.9z"/>
 </svg></div>
   </div>
   <div className='message'>
       <div><span>It's so important that new cyber security hires can hit the ground running when they start a new job.</span></div><div className="icon"><svg version="1.1"   x="0px" y="0px"  viewBox="0 0 51.6 51.6" >
 
 <path class="st0" d="M25.8,0C11.6,0,0,11.6,0,25.8c0,8.3,3.9,15.7,10.1,20.5c4.4,3.4,9.8,5.3,15.7,5.3c5.9,0,11.4-2,15.7-5.3
     c6.1-4.7,10.1-12.1,10.1-20.5C51.6,11.6,40.1,0,25.8,0z M25.8,9.1c4.3,0,7.9,3.5,7.9,7.9c0,4.3-3.5,7.9-7.9,7.9s-7.9-3.5-7.9-7.9
     C17.9,12.6,21.5,9.1,25.8,9.1z M41.5,38.6c0,0.8-0.7,1.5-1.5,1.5c-8.5,0.5-20.3,0.4-28.4-0.1c-0.8-0.1-1.5-0.7-1.5-1.6
     c0-5.1,1.8-9.7,4.6-13c0.7-0.8,1.4-1.5,2.2-2.2c0.4-0.3,1-0.3,1.4,0.1c1.1,1.3,2.6,2.3,4.4,3c1,0.4,2,0.5,3.1,0.5
     c2.7,0,5.6-1.3,7.6-3.5c0.3-0.4,1-0.5,1.4-0.1C38.8,26.6,41.5,32.2,41.5,38.6L41.5,38.6z"/>
 <path class="st1" d="M25.8,9c-4.4,0-8,3.6-8,8c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8C33.8,12.6,30.2,9,25.8,9z M25.8,24.9
     c-4.3,0-7.9-3.5-7.9-7.9c0-4.3,3.5-7.9,7.9-7.9s7.9,3.5,7.9,7.9C33.7,21.3,30.2,24.9,25.8,24.9z"/>
 </svg></div>
   </div>
   <div className='message'>
       <div><span>Some sort of tool to help test and assess cyber aptitude would be very useful</span></div><div className="icon"><svg version="1.1"   x="0px" y="0px"  viewBox="0 0 51.6 51.6" >
 
 <path class="st0" d="M25.8,0C11.6,0,0,11.6,0,25.8c0,8.3,3.9,15.7,10.1,20.5c4.4,3.4,9.8,5.3,15.7,5.3c5.9,0,11.4-2,15.7-5.3
     c6.1-4.7,10.1-12.1,10.1-20.5C51.6,11.6,40.1,0,25.8,0z M25.8,9.1c4.3,0,7.9,3.5,7.9,7.9c0,4.3-3.5,7.9-7.9,7.9s-7.9-3.5-7.9-7.9
     C17.9,12.6,21.5,9.1,25.8,9.1z M41.5,38.6c0,0.8-0.7,1.5-1.5,1.5c-8.5,0.5-20.3,0.4-28.4-0.1c-0.8-0.1-1.5-0.7-1.5-1.6
     c0-5.1,1.8-9.7,4.6-13c0.7-0.8,1.4-1.5,2.2-2.2c0.4-0.3,1-0.3,1.4,0.1c1.1,1.3,2.6,2.3,4.4,3c1,0.4,2,0.5,3.1,0.5
     c2.7,0,5.6-1.3,7.6-3.5c0.3-0.4,1-0.5,1.4-0.1C38.8,26.6,41.5,32.2,41.5,38.6L41.5,38.6z"/>
 <path class="st1" d="M25.8,9c-4.4,0-8,3.6-8,8c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8C33.8,12.6,30.2,9,25.8,9z M25.8,24.9
     c-4.3,0-7.9-3.5-7.9-7.9c0-4.3,3.5-7.9,7.9-7.9s7.9,3.5,7.9,7.9C33.7,21.3,30.2,24.9,25.8,24.9z"/>
 </svg></div>
   </div>

   </OnVisible>
            <div>  
  <OnVisible className="video-wrapper">
            {this.state.safari?<HandleImages name="hourglass"/>:    <video autoplay="true" loop="true" muted="true" playsinline="true">
                  <source src={shield} type="video/webm" />
                </video>}
              </OnVisible>
  <div>
      <p>Finding the right cyber security talent is time-consuming and costly.</p>
  </div></div>     
     </div>
            
 <div className='right'>
     <div>
     <div>

     <HandleImages name="hrChairs"/>
     <p>Today, <span>there are more than 2.8 million</span> syber security professionals around the world - <strong>but it is not enough.</strong></p>
     
     
     </div>
     
     
     </div>
     <div className="stats-wrapper">

     <div className="doc">
<div>

     <HandleImages name="hrDoc"/>
     <p>Hiring managers and Talent Acquisition leaders feel pressure to not just 'fill' positions but hire candidates for long-term success.</p>
</div>
         
</div>
<OnVisible  className="stats">


<div class="stat-row"><div class="stat">62%<svg viewBox="0 0 110 110" xmlns="http://www.w3.org/2000/svg"><circle cx="55" cy="55" r="50"></circle></svg></div><p>of their organization's cyber secuirty team is undestaffed</p></div>
<div class="stat-row"><div class="stat">57%<svg viewBox="0 0 110 110" xmlns="http://www.w3.org/2000/svg"><circle cx="55" cy="55" r="50"></circle></svg></div><p>say they currently have unfilled cyber security positions on their team.</p></div>
<div class="stat-row"><div class="stat">66%<svg viewBox="0 0 110 110" xmlns="http://www.w3.org/2000/svg"><circle cx="55" cy="55" r="50"></circle></svg></div><p>say it's difficult to retain existing cyber talent.</p></div>
<div class="stat-row"><div class="stat">50%<svg viewBox="0 0 110 110" xmlns="http://www.w3.org/2000/svg"><circle cx="55" cy="55" r="50"></circle></svg></div><p>of existing professionals resign because of poor development and promotion opportunities.</p></div>

         
</OnVisible>



     </div>
     </div>

 
 </div>

 <div className="laptop" >
     <HandleImages name="laptopIllustration"/><div><div><p>Introducing Project Ares: An award-winning online cyber security skills and assesment and training platform for hiring manager. Put job candidate skills to the test -  have them demonstrate their 'cyber fitness' in a cyber range environment.</p>

     <p>Have candidates, show that their resumé, credentials, certifications, and accreditations truly reflect their ability to protect your organization's networks.</p></div></div>
 </div>
        <div className="last">

       
 <p>Assess and Hire Cyber Talent with Confidence!</p>
 

        </div>
        <div  className= "white" >
        <OnVisible  >
<div className="icon">
<svg id="bg" viewBox="-100 -100 200 200"  
   >
 
 
<path class="st0" d="M30.9,-39.5C34.4,-34,27.5,-18.8,28.4,-6.1C29.4,6.6,38.1,16.8,36.3,22C34.6,27.3,22.3,27.5,9.9,35.7C-2.5,43.9,-15.1,60.1,-20.3,57.5C-25.5,54.9,-23.2,33.5,-24.5,19.7C-25.8,6,-30.6,-0.1,-36.6,-13.5C-42.6,-26.8,-49.8,-47.3,-43.9,-52.4C-38,-57.5,-19,-47.1,-2.6,-44C13.7,-40.9,27.5,-45,30.9,-39.5Z"/>
</svg>
<svg version="1.1"   x="0px" y="0px" viewBox="0 0 131.8 113"  >
 
<g>
    <g>
        <g>
            <path class="st0" d="M18,96.4H1.4c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9h15.7l10.8-13.4h11.6l10.8,10.8h15.4L87,70.4h18.7
                l8.1-13.4h16.6c0.5,0,0.9,0.4,0.9,0.9s-0.4,0.9-0.9,0.9h-15.6l-8.1,13.4h-19L66.3,93.7H49.4L38.7,83h-9.9L18,96.4z"/>
            <path class="st0" d="M18.2,96.9H1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4h15.4l10.8-13.4h12l10.8,10.8h15l21.5-21.5
                h18.6l8.1-13.4h16.9c0.8,0,1.4,0.6,1.4,1.4c0,0.8-0.6,1.4-1.4,1.4h-15.3L107,72.7H88L66.5,94.2H49.2L38.5,83.5H29L18.2,96.9z
                 M1.4,95.1c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4h16.3l10.8-13.4h10.4l10.8,10.8h16.5l21.5-21.5h18.9l8.1-13.4h15.9
                c0.2,0,0.4-0.2,0.4-0.4s-0.2-0.4-0.4-0.4h-16.4L106,70.9H87.3L65.8,92.4H50L39.2,81.6H28.1L17.3,95.1H1.4z"/>
        </g>
    </g>
    <g>
        <g>
            <path class="st0" d="M130.4,112.5H1.4c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9h129c0.5,0,0.9,0.4,0.9,0.9
                S130.9,112.5,130.4,112.5z"/>
            <path class="st0" d="M130.4,113H1.4c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4h129c0.8,0,1.4,0.6,1.4,1.4
                C131.8,112.4,131.2,113,130.4,113z M1.4,111.2c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4h129c0.2,0,0.4-0.2,0.4-0.4
                s-0.2-0.4-0.4-0.4H1.4z"/>
        </g>
    </g>
    <g>
        <g>
            <path class="st0" d="M76.7,72.2c-0.5,0-0.9-0.4-0.9-0.9V31.9H56.1v23.3c0,0.5-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9V30.1h23.3v41.2
                C77.6,71.8,77.2,72.2,76.7,72.2z"/>
            <path class="st0" d="M76.7,72.7c-0.8,0-1.4-0.6-1.4-1.4V32.4H56.6v22.8c0,0.8-0.6,1.4-1.4,1.4s-1.4-0.6-1.4-1.4V29.6h24.3v41.7
                C78.1,72.1,77.5,72.7,76.7,72.7z M55.6,31.4h20.7v39.9c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4V30.6H54.8v24.6
                c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4V31.4z"/>
        </g>
    </g>
    <g>
        <g>
            <path class="st0" d="M76.7,112.5c-0.5,0-0.9-0.4-0.9-0.9V92.8c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9v18.8
                C77.6,112.1,77.2,112.5,76.7,112.5z"/>
            <path class="st0" d="M76.7,113c-0.8,0-1.4-0.6-1.4-1.4V92.8c0-0.8,0.6-1.4,1.4-1.4s1.4,0.6,1.4,1.4v18.8
                C78.1,112.4,77.5,113,76.7,113z M76.7,92.4c-0.2,0-0.4,0.2-0.4,0.4v18.8c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4V92.8
                C77.1,92.6,76.9,92.4,76.7,92.4z"/>
        </g>
    </g>
    <g>
        <g>
            <path class="st0" d="M98.2,112.5c-0.5,0-0.9-0.4-0.9-0.9V79.4c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9v32.3
                C99.1,112.1,98.7,112.5,98.2,112.5z"/>
            <path class="st0" d="M98.2,113c-0.8,0-1.4-0.6-1.4-1.4V79.4c0-0.8,0.6-1.4,1.4-1.4s1.4,0.6,1.4,1.4v32.3
                C99.6,112.4,99,113,98.2,113z M98.2,78.9c-0.2,0-0.4,0.2-0.4,0.4v32.3c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4V79.4
                C98.6,79.1,98.4,78.9,98.2,78.9z"/>
        </g>
    </g>
    <g>
        <g>
            <path class="st0" d="M98.2,64.1c-0.5,0-0.9-0.4-0.9-0.9V42.6H76.7c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9h22.4v22.4
                C99.1,63.7,98.7,64.1,98.2,64.1z"/>
            <path class="st0" d="M98.2,64.6c-0.8,0-1.4-0.6-1.4-1.4V43.1H76.7c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4h22.9v22.9
                C99.6,64,99,64.6,98.2,64.6z M76.7,41.3c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4h21.1v21.1c0,0.2,0.2,0.4,0.4,0.4
                s0.4-0.2,0.4-0.4V41.3H76.7z"/>
        </g>
    </g>
    <g>
        <g>
            <path class="st0" d="M55.2,112.5c-0.5,0-0.9-0.4-0.9-0.9v-10.8c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9v10.8
                C56.1,112.1,55.7,112.5,55.2,112.5z"/>
            <path class="st0" d="M55.2,113c-0.8,0-1.4-0.6-1.4-1.4v-10.8c0-0.8,0.6-1.4,1.4-1.4s1.4,0.6,1.4,1.4v10.8
                C56.6,112.4,55.9,113,55.2,113z M55.2,100.5c-0.2,0-0.4,0.2-0.4,0.4v10.8c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4v-10.8
                C55.6,100.6,55.4,100.5,55.2,100.5z"/>
        </g>
    </g>
    <g>
        <g>
            <path class="st0" d="M55.2,85.6c-0.5,0-0.9-0.4-0.9-0.9V56.1H33.7c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9h22.4v30.5
                C56.1,85.2,55.7,85.6,55.2,85.6z"/>
            <path class="st0" d="M55.2,86.1c-0.8,0-1.4-0.6-1.4-1.4V56.6H33.7c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4h22.9v31
                C56.6,85.5,55.9,86.1,55.2,86.1z M33.7,54.8c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4h21.1v29.2c0,0.2,0.2,0.4,0.4,0.4
                s0.4-0.2,0.4-0.4v-30H33.7z"/>
        </g>
    </g>
    <g>
        <g>
            <path class="st0" d="M12.2,112.5c-0.5,0-0.9-0.4-0.9-0.9v-8.1c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9v8.1
                C13.1,112.1,12.7,112.5,12.2,112.5z"/>
            <path class="st0" d="M12.2,113c-0.8,0-1.4-0.6-1.4-1.4v-8.1c0-0.8,0.6-1.4,1.4-1.4s1.4,0.6,1.4,1.4v8.1
                C13.6,112.4,12.9,113,12.2,113z M12.2,103.1c-0.2,0-0.4,0.2-0.4,0.4v8.1c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4v-8.1
                C12.6,103.3,12.4,103.1,12.2,103.1z"/>
        </g>
    </g>
    <g>
        <g>
            <path class="st0" d="M33.7,112.5c-0.5,0-0.9-0.4-0.9-0.9V90.1c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9v21.5
                C34.6,112.1,34.2,112.5,33.7,112.5z"/>
            <path class="st0" d="M33.7,113c-0.8,0-1.4-0.6-1.4-1.4V90.1c0-0.8,0.6-1.4,1.4-1.4s1.4,0.6,1.4,1.4v21.5
                C35.1,112.4,34.4,113,33.7,113z M33.7,89.7c-0.2,0-0.4,0.2-0.4,0.4v21.5c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4V90.1
                C34.1,89.9,33.9,89.7,33.7,89.7z"/>
        </g>
    </g>
    <g>
        <g>
            <path class="st0" d="M12.2,88.3c-0.5,0-0.9-0.4-0.9-0.9V43.5h23.3V74c0,0.5-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9V45.3H13.1v42.1
                C13.1,87.9,12.7,88.3,12.2,88.3z"/>
            <path class="st0" d="M12.2,88.8c-0.8,0-1.4-0.6-1.4-1.4V43h24.3v31c0,0.8-0.6,1.4-1.4,1.4s-1.4-0.6-1.4-1.4V45.8H13.6v41.6
                C13.6,88.2,12.9,88.8,12.2,88.8z M11.8,44v43.4c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4V44.8h20.7V74c0,0.2,0.2,0.4,0.4,0.4
                s0.4-0.2,0.4-0.4V44H11.8z"/>
        </g>
    </g>
    <g>
        <g>
            <path class="st0" d="M119.7,112.5c-0.5,0-0.9-0.4-0.9-0.9V65.9c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9v45.7
                C120.6,112.1,120.2,112.5,119.7,112.5z"/>
            <path class="st0" d="M119.7,113c-0.8,0-1.4-0.6-1.4-1.4V65.9c0-0.8,0.6-1.4,1.4-1.4s1.4,0.6,1.4,1.4v45.7
                C121.1,112.4,120.5,113,119.7,113z M119.7,65.5c-0.2,0-0.4,0.2-0.4,0.4v45.7c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4V65.9
                C120.1,65.7,119.9,65.5,119.7,65.5z"/>
        </g>
    </g>
    <g>
        <g>
            <path class="st0" d="M119.7,50.7c-0.5,0-0.9-0.4-0.9-0.9V2.3H99.1v39.4c0,0.5-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9V0.5h23.3v49.3
                C120.6,50.3,120.2,50.7,119.7,50.7z"/>
            <path class="st0" d="M119.7,51.2c-0.8,0-1.4-0.6-1.4-1.4v-47H99.6v38.9c0,0.8-0.6,1.4-1.4,1.4s-1.4-0.6-1.4-1.4V0h24.3v49.8
                C121.1,50.6,120.5,51.2,119.7,51.2z M98.6,1.8h20.7v48c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4V1H97.8v40.7c0,0.2,0.2,0.4,0.4,0.4
                s0.4-0.2,0.4-0.4V1.8z"/>
        </g>
    </g>
</g>
</svg>
</div>
<span> <strong>View activity playback from candidates</strong> to assess their skills and competencies.</span>
</OnVisible>
<OnVisible  >
<div className="icon">
<svg id="bg" viewBox="-100 -100 200 200"  
   >
 
 
<path class="st0" d="M30.9,-39.5C34.4,-34,27.5,-18.8,28.4,-6.1C29.4,6.6,38.1,16.8,36.3,22C34.6,27.3,22.3,27.5,9.9,35.7C-2.5,43.9,-15.1,60.1,-20.3,57.5C-25.5,54.9,-23.2,33.5,-24.5,19.7C-25.8,6,-30.6,-0.1,-36.6,-13.5C-42.6,-26.8,-49.8,-47.3,-43.9,-52.4C-38,-57.5,-19,-47.1,-2.6,-44C13.7,-40.9,27.5,-45,30.9,-39.5Z"/>
</svg>

<svg version="1.1"  x="0px" y="0px"  
    viewBox="0 0 136.5 128" >
 
<g>
    <g>
        <path class="st0" d="M93.7,48.6H92c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2h1.7c0.7,0,1.2,0.6,1.2,1.2S94.4,48.6,93.7,48.6z"/>
    </g>
    <g>
        <path class="st0" d="M135.3,96c-0.3,0-0.5-0.1-0.8-0.3l-10.8-8.2l-0.1-0.3c-0.1-0.3-12-31.7-13.9-35.3c-1.6-3.1-2.9-3.4-6.4-3.4
            h-9.7c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2h9.7c3.7,0,6.3,0.3,8.6,4.7c1.8,3.5,12.5,31.6,13.9,35.2l10.2,7.8
            c0.5,0.4,0.7,1.2,0.2,1.8C136,95.9,135.7,96,135.3,96z"/>
    </g>
    <g>
        <path class="st0" d="M59.4,66.3c-0.2,0-0.3,0-0.5-0.1l-12.6-5.7L35.8,51l14.3,0.8l4.5,2c0.6,0.3,0.9,1,0.6,1.7
            c-0.3,0.6-1,0.9-1.7,0.6l-4-1.8l-6.7-0.4l4.9,4.4l12.3,5.6c0.6,0.3,0.9,1,0.6,1.7C60.3,66,59.8,66.3,59.4,66.3z"/>
    </g>
    <g>
        <path class="st0" d="M95.1,74.9c-0.6,0-1.2-0.5-1.2-1.1l0-0.1c0,0,0-0.1,0-0.1c-0.1-0.9-0.5-2-1.2-3.1c-0.4-0.6-0.2-1.4,0.4-1.7
            c0.6-0.4,1.4-0.2,1.7,0.4c0.9,1.5,1.4,2.8,1.5,4.1c0,0.1,0,0.2,0,0.3c0.1,0.7-0.5,1.3-1.2,1.4C95.2,74.9,95.1,74.9,95.1,74.9z"/>
    </g>
    <g>
        <path class="st0" d="M101.9,54.1c-0.2,0-0.4,0-0.6-0.2l-8.2-4.5c-0.6-0.3-0.8-1.1-0.5-1.7c0.3-0.6,1.1-0.8,1.7-0.5l8.2,4.5
            c0.6,0.3,0.8,1.1,0.5,1.7C102.8,53.8,102.4,54.1,101.9,54.1z"/>
    </g>
    <g>
        <path class="st0" d="M87.3,63.4c-0.3,0-0.6-0.1-0.9-0.4c-0.3-0.3-0.5-0.5-0.8-0.8l-9.8-6.4c-2.4,1-11.3,4.5-17.3,5.1l-0.1,0
            c-0.5,0-4.5-0.2-6.2-7.8l-0.2-1l27-13.4l9,4.9c0.6,0.3,0.8,1.1,0.5,1.7c-0.3,0.6-1.1,0.8-1.7,0.5l-7.8-4.3l-24,11.9
            c1.2,4.4,3.3,4.8,3.5,4.9c6.4-0.6,16.9-5.1,17-5.1l0.6-0.3l11.2,7.3c0.3,0.3,0.6,0.6,0.9,0.9c0.5,0.5,0.5,1.3,0,1.8
            C88,63.3,87.6,63.4,87.3,63.4z"/>
    </g>
    <g>
        <path class="st0" d="M93.7,71c-0.4,0-0.8-0.2-1.1-0.6c-1.1-1.9-3.1-4.3-6.2-7.3c-0.5-0.5-0.5-1.3,0-1.8c0.5-0.5,1.3-0.5,1.8,0
            c3.2,3.2,5.3,5.7,6.6,7.8c0.4,0.6,0.2,1.4-0.4,1.7C94.1,70.9,93.9,71,93.7,71z"/>
    </g>
    <g>
        <path class="st0" d="M93.7,49.6c-0.2,0-0.4,0-0.6-0.2L86.7,46c-0.6-0.3-0.8-1.1-0.5-1.7c0.3-0.6,1.1-0.8,1.7-0.5l6.4,3.5
            c0.6,0.3,0.8,1.1,0.5,1.7C94.6,49.4,94.1,49.6,93.7,49.6z"/>
    </g>
    <g>
        <path class="st0" d="M114.1,117c-0.3,0-0.5-0.1-0.8-0.3l-9.6-7.4c-1.2-0.2-5.2-0.9-10.3-2.5c-0.7-0.2-1-0.9-0.8-1.6
            c0.2-0.7,0.9-1,1.6-0.8c5.8,1.8,10.3,2.5,10.3,2.5l0.3,0l10.1,7.8c0.5,0.4,0.6,1.2,0.2,1.8C114.8,116.8,114.4,117,114.1,117z"/>
    </g>
    <g>
        <path class="st0" d="M87.3,104.6c-0.2,0-0.3,0-0.5-0.1c-2.6-1.1-5-2.2-7.1-3.5l-0.2-0.1L62.1,80.7l0-0.4c0-0.1-0.6-8.8-3.9-15
            l-0.4-0.8l0.6-0.6c0.1-0.1,2.3-2.6,6.2-2.1c5.2,0.6,10.6,6.3,16,16.7c1.1,0.4,4,1.3,6.8,1.4c0.7,0,1.2,0.6,1.2,1.3
            s-0.6,1.2-1.3,1.2c-3.9-0.2-7.9-1.7-8.1-1.7l-0.5-0.2l-0.2-0.4c-6.3-12.3-11.2-15.4-14.2-15.8c-1.6-0.2-2.8,0.3-3.5,0.8
            c2.8,5.8,3.5,12.9,3.7,14.7l16.6,19.2c2,1.2,4.2,2.2,6.6,3.2c0.6,0.3,0.9,1,0.7,1.6C88.3,104.3,87.8,104.6,87.3,104.6z"/>
    </g>
    <g>
        <path class="st0" d="M88,82.4c-0.3,0-0.5,0-0.8,0c-0.7,0-1.2-0.6-1.2-1.3c0-0.7,0.6-1.2,1.3-1.2c2,0.1,3.4-0.2,4.3-0.9
            c0.6-0.4,1.3-0.3,1.7,0.3c0.4,0.6,0.3,1.3-0.3,1.7C91.9,82,90.2,82.4,88,82.4z"/>
    </g>
    <g>
        <path class="st0" d="M93.7,106.9c-0.1,0-0.2,0-0.4-0.1c-2.2-0.7-4.4-1.5-6.5-2.3c-0.6-0.3-0.9-1-0.7-1.6c0.3-0.6,1-0.9,1.6-0.7
            c2,0.8,4.1,1.6,6.3,2.3c0.7,0.2,1,0.9,0.8,1.6C94.7,106.5,94.2,106.9,93.7,106.9z"/>
    </g>
    <g>
        <path class="st0" d="M95.1,75c-0.2,0-0.3,0-0.5-0.1l-1.4-0.6c-0.6-0.3-0.9-1-0.6-1.7c0.3-0.6,1-0.9,1.7-0.6l1.4,0.6
            c0.6,0.3,0.9,1,0.6,1.7C96,74.7,95.6,75,95.1,75z"/>
    </g>
    <g>
        <path class="st0" d="M87.3,71.4c-0.2,0-0.3,0-0.5-0.1L62.2,60.1c-0.6-0.3-0.9-1-0.6-1.7c0.3-0.6,1-0.9,1.7-0.6L87.8,69
            c0.6,0.3,0.9,1,0.6,1.7C88.2,71.2,87.8,71.4,87.3,71.4z"/>
    </g>
    <g>
        <path class="st0" d="M93.7,74.3c-0.2,0-0.3,0-0.5-0.1l-6.4-2.9c-0.6-0.3-0.9-1-0.6-1.7c0.3-0.6,1-0.9,1.7-0.6l6.4,2.9
            c0.6,0.3,0.9,1,0.6,1.7C94.6,74.1,94.2,74.3,93.7,74.3z"/>
    </g>
    <g>
        <path class="st0" d="M87.3,79c-0.2,0-0.3,0-0.5-0.1L75,73.5c-0.6-0.3-0.9-1-0.6-1.7c0.3-0.6,1-0.9,1.7-0.6l11.8,5.4
            c0.6,0.3,0.9,1,0.6,1.7C88.2,78.7,87.8,79,87.3,79z"/>
    </g>
    <g>
        <path class="st0" d="M92.4,81.3c-0.2,0-0.3,0-0.5-0.1l-5.1-2.3c-0.6-0.3-0.9-1-0.6-1.7c0.3-0.6,1-0.9,1.7-0.6l5.1,2.3
            c0.6,0.3,0.9,1,0.6,1.7C93.4,81,92.9,81.3,92.4,81.3z"/>
    </g>
    <g>
        <path class="st0" d="M93.7,81.9c-0.2,0-0.3,0-0.5-0.1l-1.3-0.6c-0.6-0.3-0.9-1-0.6-1.7c0.3-0.6,1-0.9,1.7-0.6l1.3,0.6
            c0.6,0.3,0.9,1,0.6,1.7C94.6,81.6,94.2,81.9,93.7,81.9z"/>
    </g>
    <g>
        <path class="st0" d="M112.7,90.6l-19.5-8.9c-0.6-0.3-0.9-1-0.6-1.7c0.3-0.6,1-0.9,1.7-0.6l18.2,8.3c0.8-0.7,2.3-2.1,1.9-3.9
            l-19.8-9c-0.6-0.3-0.9-1-0.6-1.7c0.3-0.6,1-0.9,1.7-0.6l20.8,9.5l0.2,0.5c1.4,3.7-1.6,6.7-3.4,7.8L112.7,90.6z"/>
    </g>
    <g>
        <path class="st0" d="M87.3,67.4c-0.2,0-0.4,0-0.5-0.1l-8.4-4c-1.6,0.1-3.7,0.4-6.3,1c-0.7,0.2-1.3-0.3-1.5-0.9
            c-0.2-0.7,0.3-1.3,0.9-1.5c3-0.7,5.4-1.1,7.1-1.1l0.3,0l8.9,4.3c0.6,0.3,0.9,1,0.6,1.7C88.2,67.2,87.8,67.4,87.3,67.4z"/>
    </g>
    <g>
        <path class="st0" d="M93,70.2c-0.2,0-0.4,0-0.5-0.1l-5.7-2.7c-0.6-0.3-0.9-1-0.6-1.7s1-0.9,1.7-0.6l5.7,2.7c0.6,0.3,0.9,1,0.6,1.7
            C93.9,69.9,93.4,70.2,93,70.2z"/>
    </g>
    <g>
        <path class="st0" d="M56.4,69.1L56,69.1c-6.3-1.4-6.8-5.8-6.8-6l-0.1-0.6l1.6-1.7c0.5-0.5,1.3-0.5,1.8-0.1
            c0.5,0.5,0.5,1.3,0.1,1.8l-0.7,0.8c0.3,0.8,1.3,2.5,4.4,3.2c0.6-0.2,1.8-0.6,3.4-1.2c0.7-0.2,1.4,0.1,1.6,0.8
            c0.2,0.7-0.1,1.4-0.8,1.6c-2.2,0.8-3.7,1.3-3.7,1.3L56.4,69.1z"/>
    </g>
    <g>
        <path class="st0" d="M95,128H0V11.8h21.9v6c0,0.7-0.6,1.2-1.2,1.2s-1.2-0.6-1.2-1.2v-3.5H2.5v111.2h90v-16.1
            c0-0.7,0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2V128z"/>
    </g>
    <g>
        <path class="st0" d="M93.7,49.6c-0.7,0-1.2-0.6-1.2-1.2v-1c0-0.7,0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2v1C95,49.1,94.4,49.6,93.7,49.6z
            "/>
    </g>
    <g>
        <path class="st0" d="M93.7,44.8c-0.7,0-1.2-0.6-1.2-1.2V14.3H75.6v3.5c0,0.7-0.6,1.2-1.2,1.2s-1.2-0.6-1.2-1.2v-6H95v31.8
            C95,44.2,94.4,44.8,93.7,44.8z"/>
    </g>
    <g>
        <path class="st0" d="M75.6,23.5H19.4v-5.7c0-0.7,0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2V21h51.2v-3.2c0-0.7,0.6-1.2,1.2-1.2
            s1.2,0.6,1.2,1.2V23.5z"/>
    </g>
    <g>
        <path class="st0" d="M88.6,117.3H6.4V16.5h14.2c0.7,0,1.2,0.6,1.2,1.2S21.3,19,20.6,19H8.9v95.8h77.2v-7.7c0-0.7,0.6-1.2,1.2-1.2
            s1.2,0.6,1.2,1.2V117.3z"/>
    </g>
    <g>
        <path class="st0" d="M87.3,42.3c-0.7,0-1.2-0.6-1.2-1.2V19H74.3c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2h14.2v24.6
            C88.6,41.8,88,42.3,87.3,42.3z"/>
    </g>
    <g>
        <path class="st0" d="M74.3,14.3c-0.7,0-1.2-0.6-1.2-1.2v-2.9h-7.7L65,9.8c-4.7-4.7-11-7.3-17.7-7.3c-6.7,0-12.9,2.6-17.7,7.3
            l-0.4,0.4h-7.5V13c0,0.7-0.6,1.2-1.2,1.2s-1.2-0.6-1.2-1.2V7.6h9C33.5,2.7,40.2,0,47.4,0c7.1,0,13.9,2.7,19,7.6h9.2V13
            C75.6,13.7,75,14.3,74.3,14.3z"/>
    </g>
    <g>
        <path class="st1" d="M74.3,13"/>
    </g>
    <g>
        <path class="st1" d="M74.3,17.8"/>
    </g>
    <g>
        <path class="st1" d="M20.6,17.8"/>
    </g>
    <g>
        <path class="st1" d="M20.6,13"/>
    </g>
    <g>
        <path class="st0" d="M32.4,94.3H18.7V80.7h13.6V94.3z M21.2,91.8h8.6v-8.6h-8.6V91.8z"/>
    </g>
    <g>
        <path class="st0" d="M32.4,46.3H18.7V32.7h13.6V46.3z M21.2,43.8h8.6v-8.6h-8.6V43.8z"/>
    </g>
    <g>
        <path class="st0" d="M32.4,70.3H18.7V56.7h13.6V70.3z M21.2,67.8h8.6v-8.6h-8.6V67.8z"/>
    </g>
</g>
</svg>



 

</div>
<span>   <strong>Enhance the screening process</strong> by having candiadtes complete built-in practitioner activites aligned to specified work roles of the positions.</span>
</OnVisible  >
   <OnVisible  >
<div className="icon">
<svg id="bg" viewBox="-100 -100 200 200"  
   >
 
 
<path class="st0" d="M30.9,-39.5C34.4,-34,27.5,-18.8,28.4,-6.1C29.4,6.6,38.1,16.8,36.3,22C34.6,27.3,22.3,27.5,9.9,35.7C-2.5,43.9,-15.1,60.1,-20.3,57.5C-25.5,54.9,-23.2,33.5,-24.5,19.7C-25.8,6,-30.6,-0.1,-36.6,-13.5C-42.6,-26.8,-49.8,-47.3,-43.9,-52.4C-38,-57.5,-19,-47.1,-2.6,-44C13.7,-40.9,27.5,-45,30.9,-39.5Z"/>
</svg>
<svg version="1.1"  x="0px" y="0px"   viewBox="0 0 149.1 136.1"  >
 
<g>
    <g>
        <circle class="st0" cx="74.5" cy="134.8" r="1.2"/>
    </g>
    <g>
        <path class="st0" d="M74.5,136.1c-0.7,0-1.2-0.6-1.2-1.2c0-0.6,0.4-1.1,1-1.2c0.7-0.1,1.5,0.5,1.5,1.2c0,0.6-0.4,1.1-1,1.2
            C74.6,136.1,74.6,136.1,74.5,136.1z"/>
    </g>
    <g>
        <g>
            <path class="st0" d="M27,45.3c-7.7,0-14-7.4-14-16.4s6.3-16.4,14-16.4s14,7.4,14,16.4S34.8,45.3,27,45.3z M27,14.9
                c-6.3,0-11.5,6.3-11.5,13.9c0,7.7,5.2,13.9,11.5,13.9s11.5-6.3,11.5-13.9C38.5,21.2,33.4,14.9,27,14.9z"/>
        </g>
        <g>
            <path class="st0" d="M11.1,81.1c-0.7,0-1.2-0.6-1.2-1.2V63.6c0-0.7,0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2v16.3
                C12.3,80.6,11.8,81.1,11.1,81.1z"/>
        </g>
        <g>
            <path class="st0" d="M45.7,47.6c-0.1,0-0.1,0-0.2,0c-0.4,0-0.6-0.1-0.6-0.1c-0.1,0-5.9-0.3-8.4-0.3c-2.9,0-4-2.7-4.1-4.1
                c-0.1-0.7,0.4-1.3,1.1-1.4c0.7-0.1,1.3,0.4,1.4,1.1c0,0.3,0.3,1.8,1.7,1.8c2.6,0,8.1,0.3,8.4,0.3c0,0,0.3,0,0.9,0.1
                c0.7,0.1,1.2,0.7,1.1,1.4C46.9,47.1,46.4,47.6,45.7,47.6z"/>
        </g>
        <g>
            <path class="st0" d="M1.3,74.3C1.2,74.3,1.2,74.3,1.3,74.3C0.5,74.3,0,73.7,0,73c0-0.1,0.2-10.5,0.2-18.4c0-7.3,6-9.3,9.1-9.3
                c0.2,0,5.8-0.3,8.4-0.3c1.4,0,1.6-1.5,1.7-1.8c0.1-0.7,0.7-1.2,1.4-1.1c0.7,0.1,1.2,0.7,1.1,1.4c-0.2,1.4-1.2,4.1-4.1,4.1
                c-2.5,0-8.3,0.3-8.3,0.3c-0.7,0-6.7,0.2-6.7,6.8c0,7.9-0.2,18.4-0.2,18.5C2.5,73.7,1.9,74.3,1.3,74.3z"/>
        </g>
        <g>
            <path class="st0" d="M121.9,45.3c-7.7,0-14-7.4-14-16.4s6.3-16.4,14-16.4s14,7.4,14,16.4S129.6,45.3,121.9,45.3z M121.9,14.9
                c-6.3,0-11.5,6.3-11.5,13.9c0,7.7,5.2,13.9,11.5,13.9s11.5-6.3,11.5-13.9C133.4,21.2,128.3,14.9,121.9,14.9z"/>
        </g>
        <g>
            <path class="st0" d="M138.2,81.1c-0.7,0-1.2-0.6-1.2-1.2V63.6c0-0.7,0.6-1.2,1.2-1.2s1.2,0.6,1.2,1.2v16.3
                C139.5,80.6,138.9,81.1,138.2,81.1z"/>
        </g>
        <g>
            <path class="st0" d="M147.9,74c-0.7,0-1.2-0.5-1.2-1.2c0-0.1-0.2-10.6-0.2-18.5c0-6.5-6-6.7-6.7-6.8c-0.1,0-5.9-0.3-8.4-0.3
                c-2.9,0-4-2.7-4.1-4.1c-0.1-0.7,0.4-1.3,1.1-1.4c0.7-0.1,1.3,0.4,1.4,1.1c0,0.3,0.3,1.8,1.7,1.8c2.6,0,8.2,0.3,8.5,0.3
                c0,0,0,0,0,0c3.1,0,9.1,1.9,9.1,9.2c0,7.9,0.2,18.3,0.2,18.4C149.1,73.4,148.6,74,147.9,74C147.9,74,147.9,74,147.9,74z"/>
        </g>
        <g>
            <path class="st0" d="M103.3,47.9c-0.6,0-1.2-0.5-1.2-1.1c-0.1-0.7,0.4-1.3,1.1-1.4c0.6-0.1,1-0.1,1.1-0.1c0.2,0,5.8-0.3,8.4-0.3
                c1.4,0,1.6-1.5,1.7-1.8c0.1-0.7,0.7-1.2,1.4-1.1c0.7,0.1,1.2,0.7,1.1,1.4c-0.2,1.4-1.2,4.1-4.1,4.1c-2.5,0-8.3,0.3-8.3,0.3
                c-0.1,0-0.4,0-0.8,0.1C103.4,47.9,103.3,47.9,103.3,47.9z"/>
        </g>
        <g>
            <path class="st0" d="M74.4,36.5c-8.6,0-15.5-8.2-15.5-18.3C58.9,8.2,65.8,0,74.4,0s15.5,8.2,15.5,18.3
                C89.9,28.3,82.9,36.5,74.4,36.5z M74.4,2.5c-7.2,0-13,7.1-13,15.8S67.2,34,74.4,34s13-7.1,13-15.8S81.6,2.5,74.4,2.5z"/>
        </g>
        <g>
            <path class="st0" d="M91,38.8C91,38.8,91,38.8,91,38.8c-2.8-0.1-4.8-0.2-6-0.2c-3.2,0-4.3-2.9-4.5-4.4c-0.1-0.7,0.4-1.3,1.1-1.4
                c0.7-0.1,1.3,0.4,1.4,1.1c0,0.2,0.3,2.2,2,2.2c1.3,0,3.3,0.1,6.1,0.2c0.7,0,1.2,0.6,1.2,1.3C92.3,38.3,91.7,38.8,91,38.8z"/>
        </g>
        <g>
            <path class="st0" d="M103.3,47.9c-0.7,0-1.2-0.6-1.2-1.2c0-7.6-7.3-7.7-7.6-7.7c-0.1,0-1.6-0.1-3.4-0.2c-0.7,0-1.2-0.6-1.2-1.3
                s0.6-1.2,1.3-1.2c1.9,0.1,3.4,0.2,3.4,0.2c0,0,0,0,0,0c3.4,0,10,2.1,10,10.2C104.5,47.4,104,47.9,103.3,47.9
                C103.3,47.9,103.3,47.9,103.3,47.9z"/>
        </g>
        <g>
            <path class="st0" d="M103.4,62.5c-0.7,0-1.2-0.5-1.2-1.2c-0.1-5.7-0.1-10.6-0.1-14.5l0-0.1c0-0.7,0.6-1.2,1.2-1.2
                c0.7,0,1.2,0.5,1.2,1.2c0,0,0,0.1,0,0.1c0,3.9,0,8.8,0.1,14.6C104.6,62,104.1,62.5,103.4,62.5C103.4,62.5,103.4,62.5,103.4,62.5z
                "/>
        </g>
        <g>
            <path class="st0" d="M57.9,39.2c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.3,1.2-1.3c2.8-0.1,4.8-0.2,6.1-0.2c1.7,0,2-2.1,2-2.2
                c0.1-0.7,0.7-1.2,1.4-1.1c0.7,0.1,1.2,0.7,1.1,1.4c-0.2,1.5-1.3,4.4-4.5,4.4C62.7,39,60.7,39.1,57.9,39.2
                C57.9,39.2,57.9,39.2,57.9,39.2z"/>
        </g>
        <g>
            <path class="st0" d="M45.6,62.5C45.6,62.5,45.6,62.5,45.6,62.5c-0.7,0-1.3-0.6-1.3-1.3c0-3.8,0.1-9.4,0.1-14.2c0-0.2,0-0.4,0-0.6
                l0-0.2c0-0.7,0.6-1.2,1.3-1.2c0.7,0,1.2,0.6,1.2,1.3l0,0.3c0,0.1,0,0.2,0,0.4c0,4.8-0.1,10.4-0.1,14.2
                C46.8,62,46.3,62.5,45.6,62.5z"/>
        </g>
        <g>
            <path class="st0" d="M45.7,47.6C45.7,47.6,45.7,47.6,45.7,47.6c-0.8,0-1.3-0.6-1.2-1.3c0.4-7.4,6.8-9.4,10-9.4
                c0,0,1.5-0.1,3.3-0.2c0.7,0,1.3,0.5,1.3,1.2s-0.5,1.3-1.2,1.3c-1.9,0.1-3.4,0.2-3.4,0.2c-0.4,0-7.2,0.1-7.6,7
                C46.9,47.1,46.4,47.6,45.7,47.6z"/>
        </g>
        <g>
            <path class="st0" d="M45.6,62.5c-0.7,0-1.2-0.5-1.2-1.2c0-0.7,0.5-1.3,1.2-1.3c2.4-0.2,4.8-0.4,7.1-0.8c0.7-0.1,1.3,0.3,1.4,1
                c0.1,0.7-0.3,1.3-1,1.4C50.6,62.1,48.2,62.4,45.6,62.5C45.6,62.5,45.6,62.5,45.6,62.5z"/>
        </g>
        <g>
            <path class="st0" d="M52.9,61.7c-0.6,0-1.1-0.4-1.2-1c-0.1-0.7,0.3-1.3,1-1.4c1.4-0.2,2.6-0.5,3.6-0.7c0.7-0.2,1.3,0.3,1.5,0.9
                s-0.3,1.3-0.9,1.5c-1.1,0.3-2.3,0.5-3.7,0.8C53,61.7,52.9,61.7,52.9,61.7z"/>
        </g>
        <g>
            <path class="st0" d="M74.5,51.4c-0.2,0-0.4,0-0.6-0.1c-0.6-0.3-0.9-1.1-0.6-1.7c0-0.1,0.1-0.1,0.1-0.2c0.4-0.6,1.2-0.7,1.7-0.3
                c0.6,0.4,0.7,1.1,0.3,1.7C75.3,51.2,74.9,51.4,74.5,51.4z"/>
        </g>
        <g>
            <path class="st0" d="M56.5,60.9c-0.6,0-1.1-0.4-1.2-1c-0.2-0.7,0.3-1.3,0.9-1.5c12.6-3,17.2-9,17.3-9c0.4-0.5,1.2-0.7,1.8-0.2
                c0.6,0.4,0.7,1.2,0.2,1.8c-0.2,0.3-5.2,6.7-18.7,10C56.7,60.9,56.6,60.9,56.5,60.9z"/>
        </g>
        <g>
            <path class="st0" d="M74.5,136.1c-0.2,0-0.3,0-0.5-0.1c-18.1-7.1-29.9-22.3-34.1-44c-3.2-16.3-1-30.2-0.9-30.8l0.2-1.1h1.1
                c1.8,0,3.5-0.1,5.3-0.2c0.7,0,1.3,0.5,1.3,1.2c0,0.7-0.5,1.3-1.2,1.3c-1.5,0.1-2.9,0.2-4.4,0.2c-0.9,7.7-5,55.9,33.6,71
                c0.6,0.3,1,1,0.7,1.6C75.4,135.8,75,136.1,74.5,136.1z"/>
        </g>
        <g>
            <path class="st0" d="M74.5,136.1c-0.5,0-1-0.3-1.2-0.8c-0.3-0.6,0.1-1.4,0.7-1.6c38.6-15.1,34.6-63.2,33.6-71
                c-1.4,0-2.9-0.1-4.4-0.2c-0.7,0-1.2-0.6-1.2-1.3c0-0.7,0.6-1.2,1.3-1.2c1.8,0.1,3.5,0.2,5.3,0.2h1.1l0.2,1.1
                c0.1,0.6,2.3,14.5-0.9,30.8c-4.2,21.7-16,36.9-34.1,44C74.8,136.1,74.6,136.1,74.5,136.1z"/>
        </g>
        <g>
            <path class="st0" d="M103.4,62.5C103.3,62.5,103.3,62.5,103.4,62.5c-2.5-0.2-4.9-0.4-7.3-0.8c-0.7-0.1-1.1-0.8-1-1.4
                c0.1-0.7,0.8-1.1,1.4-1c2.3,0.4,4.6,0.7,7,0.8c0.7,0,1.2,0.6,1.2,1.3C104.6,62,104,62.5,103.4,62.5z"/>
        </g>
        <g>
            <path class="st0" d="M96.3,61.7c-0.1,0-0.1,0-0.2,0c-1.4-0.2-2.7-0.5-3.7-0.7c-0.7-0.2-1.1-0.8-0.9-1.5c0.2-0.7,0.8-1.1,1.5-0.9
                c1,0.2,2.2,0.5,3.6,0.7c0.7,0.1,1.1,0.8,1,1.4C97.4,61.3,96.9,61.7,96.3,61.7z"/>
        </g>
        <g>
            <path class="st0" d="M92.6,61c-0.1,0-0.2,0-0.3,0c-13.5-3.2-18.6-9.7-18.8-10c-0.4-0.5-0.3-1.3,0.2-1.8c0.5-0.4,1.3-0.3,1.8,0.2
                c0.2,0.2,4.8,6.1,17.4,9.1c0.7,0.2,1.1,0.8,0.9,1.5C93.7,60.6,93.2,61,92.6,61z"/>
        </g>
        <g>
            <path class="st0" d="M74.5,51.4c-0.4,0-0.8-0.2-1.1-0.6c-0.4-0.6-0.2-1.3,0.3-1.7c0.6-0.4,1.3-0.3,1.7,0.3c0,0,0.1,0.1,0.1,0.2
                c0.3,0.6,0.1,1.4-0.6,1.7C74.9,51.4,74.7,51.4,74.5,51.4z"/>
        </g>
        <g>
            <path class="st0" d="M92.6,68.2c-0.1,0-0.1,0-0.2,0c-13.8-2.2-18.7-8.6-18.9-8.9c-0.4-0.6-0.3-1.3,0.3-1.8
                c0.6-0.4,1.3-0.3,1.7,0.3c0,0.1,4.6,5.9,17.3,7.9c0.7,0.1,1.1,0.7,1,1.4C93.7,67.7,93.2,68.2,92.6,68.2z"/>
        </g>
        <g>
            <path class="st0" d="M96.2,68.6c0,0-0.1,0-0.1,0c-1.4-0.1-2.6-0.3-3.7-0.4c-0.7-0.1-1.1-0.7-1-1.4c0.1-0.7,0.8-1.2,1.4-1
                c1,0.2,2.2,0.3,3.5,0.4c0.7,0.1,1.2,0.7,1.1,1.4C97.4,68.1,96.8,68.6,96.2,68.6z"/>
        </g>
        <g>
            <path class="st0" d="M74.5,128c-0.5,0-1-0.3-1.2-0.8c-0.3-0.6,0.1-1.4,0.7-1.6c30.7-12,27.8-49.9,27-56.7c-1.6,0-3.2-0.1-4.9-0.3
                c-0.7-0.1-1.2-0.7-1.1-1.4c0.1-0.7,0.7-1.2,1.4-1.1c2,0.2,3.8,0.3,5.8,0.3h1.1l0.2,1.1c0.1,0.5,7,46.6-28.4,60.5
                C74.8,128,74.6,128,74.5,128z"/>
        </g>
    </g>
</g>
</svg>

 
</div>
<span>Use Project Ares as a professional development tool to <strong>train teams and provide opportunities to grow</strong> in skill and knowledge = leading to happy employees and lower churn.</span>
</OnVisible  >

</div>
      </div>
    )
  }
}

export default GovInfo
